import { atomic } from "../atomic.css";
import { LoadingIndicator } from "../loading-indicator";

export function LoadingView() {
  return (
    <div
      className={atomic({
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        minBlockSize: "half-viewport",
        padding: {
          default: 24,
          medium: 56,
        },
      })}
    >
      <LoadingIndicator />
    </div>
  );
}
